export default "__VITE_ASSET__8bde0020__"